import { REHYDRATE } from "redux-persist";
import { LOGIN_INIT, LOGOUT } from "actions/loginStateActions";
import {
    AUDIT_CERTIFICATION_LIST_FETCH_BEGIN,
    AUDIT_CERTIFICATION_LIST_FETCH_SUCCESS,
    AUDIT_CERTIFICATION_LIST_FETCH_FAIL,
} from "actions/auditCertificationActions";

const INITIAL_STATE = { data: [], status: "idle" };

export default function auditCertificationListReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case REHYDRATE:
            return state;

        case AUDIT_CERTIFICATION_LIST_FETCH_BEGIN:
            return { ...INITIAL_STATE, status: "fetching" };

        case AUDIT_CERTIFICATION_LIST_FETCH_SUCCESS:
            return { data: action.data, status: "idle" };

        case AUDIT_CERTIFICATION_LIST_FETCH_FAIL:
            return { ...INITIAL_STATE, status: "failed", failReason: action.reason };

        case LOGIN_INIT:
        case LOGOUT:
            return INITIAL_STATE;

        default:
            return state;
    }
}
